import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { JobListVariables } from '../models/job-list-variables.model';
import { JobsSearchResult } from '../models/job-searsch-result.model';

@Injectable({
  providedIn: 'root',
})
export class JobsListByNameGQL extends Query<JobsSearchResult, JobListVariables> {
  override document = gql`
    query ($search: String, $take: Int) {
      jobs(
        includeInactive: false
        filterByCountryCode: true
        take: $take
        order: { name: ASC }
        where: { or: [{ name: { contains: $search } }, { accountNumber: { contains: $search } }] }
      ) {
        items {
          name
          key
          accountNumber
          isActive
          jobType
          salesRep {
            email
          }
          secondarySalesRep {
            email
          }
        }
      }
    }
  `;
}
